import { useCallback } from 'react'

interface UseStockKeyboardNavigationProps {
	stockOptions: any[]
	selectedOptionIndex: number
	setSelectedOptionIndex: (index: number) => void
	onSelect: (path: string) => void
	returnToMainSearch: () => void
	stockSearchValue: string
}

export const useStockKeyboardNavigation = ({
	stockOptions,
	selectedOptionIndex,
	setSelectedOptionIndex,
	onSelect,
	returnToMainSearch,
	stockSearchValue
}: UseStockKeyboardNavigationProps) => {
	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent) => {
			switch (e.key) {
				case 'ArrowDown':
					e.preventDefault()
					if (selectedOptionIndex < stockOptions.length - 1) {
						setSelectedOptionIndex(selectedOptionIndex + 1)
					}
					break
				case 'ArrowUp':
					e.preventDefault()
					if (selectedOptionIndex > 0) {
						setSelectedOptionIndex(selectedOptionIndex - 1)
					}
					break
				case 'Enter':
					e.preventDefault()
					if (stockOptions[selectedOptionIndex]) {
						onSelect(stockOptions[selectedOptionIndex].path)
					}
					break
				case 'Escape':
					e.preventDefault()
					returnToMainSearch()
					break
				case 'Backspace':
					if (stockSearchValue === '') {
						e.preventDefault()
						returnToMainSearch()
					}
					break
				default:
					break
			}
		},
		[stockOptions, selectedOptionIndex, setSelectedOptionIndex, onSelect, returnToMainSearch, stockSearchValue]
	)

	return handleKeyDown
}
